/* Custom Product Slider Script - Enable Dots */
if (!customElements.get('custom-product-slider')) {
  class CustomProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container?.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Wait for Flickity to load
      if (typeof Flickity === 'undefined') {
        setTimeout(() => this.connectedCallback(), 100);
        return;
      }

      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail') || [];
      // Only surface prev/next arrows when there's more than one navigable
      // slide. Matches the base main-product.liquid pattern that gates the
      // slideshow-arrows render on product.media.size > 1. Count uses the
      // same cellSelector Flickity uses so variant-filtered images stay in
      // sync (a colour-variant product could have 1 active image while
      // 5 exist in DOM — no arrows needed).
      const activeSlideCount = this.querySelectorAll('.product-images__slide.is-active').length;
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: activeSlideCount > 1,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        draggable: true,
        freeScroll: false,
        setGallerySize: true
      };
    }

    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;

      // Force dots creation
      if (this.flkty.pageDots) {
        this.flkty.pageDots.setDots();
      }

      this.setupEvents();
      this.setupProductGallery();
    }

    setupEvents() {
      const _this = this;

      this.video_containers.forEach((container) => {
        container.querySelector('button')?.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });

      this.flkty.on('change', (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex]?.element;
        let previous_media = previous_slide?.querySelector('.product-single__media');

        if (previous_media?.classList.contains('product-single__media-external-video')) {
          let video = previous_media.querySelector('iframe');
          if (video) {
            video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
          }
        }

        if (previous_media?.classList.contains('product-single__media-native-video')) {
          let video = previous_media.querySelector('video');
          if (video) video.pause();
        }

        // Sync active thumbnail to current slide so the thumbnail row highlights
        // the same media as the main image. Mirrors ProductSlider in product.js.
        if (_this.thumbnails && _this.thumbnails.length) {
          const active_thumbs = Array.from(_this.thumbnails).filter((el) =>
            el.classList.contains('is-active')
          );
          const active_thumb = active_thumbs[index] || active_thumbs[0];
          if (active_thumb) {
            _this.thumbnails.forEach((item) => item.classList.remove('is-initial-selected'));
            active_thumb.classList.add('is-initial-selected');

            requestAnimationFrame(() => {
              if (active_thumb.offsetParent === null) return;
              const parent = active_thumb.offsetParent;
              const halfH = parent.clientHeight / 2;
              const halfW = parent.clientWidth / 2;
              active_thumb.parentElement.scrollTo({
                left: active_thumb.offsetLeft - halfW + active_thumb.clientWidth / 2,
                top: active_thumb.offsetTop - halfH + active_thumb.clientHeight / 2,
                behavior: 'smooth'
              });
            });
          }
        }

        _this.selectedIndex = index;
      });

      // Thumbnail click → jump main slider to that media. Deferred to next tick
      // so thumbnails have finished any variant-image filtering before we bind.
      setTimeout(() => {
        const clickable = Array.from(this.thumbnails).filter((el) => el.clientWidth > 0);
        clickable.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnails.forEach((el) => el.classList.remove('is-initial-selected'));
            thumbnail.classList.add('is-initial-selected');
            this.flkty.select(index);
          });
        });
      });
    }

    setupProductGallery() {
      // Gallery setup logic if needed
    }
  }

  customElements.define('custom-product-slider', CustomProductSlider);
}
